import { Component, Input } from "@angular/core";

@Component({
    selector: "list-skeleton",
    templateUrl: "./list-skeleton.component.html",
    styleUrls: ["./list-skeleton.component.scss"],
    standalone: false
})
export class ListSkeletonComponent {
  @Input() elements = 10;

  elementArray() {
    return Array(this.elements);
  }
}
